import styled, { css } from 'styled-components';
import { gridConfig } from '../../fuse-responsive-grid/src/grid';
import defaultConfig from './config';

const { componentName } = defaultConfig;

const sizeConfig = {
	xsmall: {
		height: 'var(--spacing-global-space5)',
		width: 'var(--spacing-global-space5)',
	},
	small: {
		height: 'var(--spacing-global-space6)',
		width: 'var(--spacing-global-space6)',
	},
	medium: {
		height: 'var(--spacing-global-space7)',
		width: 'var(--spacing-global-space7)',
	},
	large: {
		height: 'var(--spacing-global-space9)',
		width: 'var(--spacing-global-space9)',
	},
};

const responsiveCss = css`
	width: ${sizeConfig.xsmall.width};
	height: ${sizeConfig.xsmall.height};

	@media only screen and (min-width: ${gridConfig.s.minWidth}) {
		width: ${sizeConfig.small.width};
		height: ${sizeConfig.small.height};
	}

	@media only screen and (min-width: ${gridConfig.m.minWidth}) {
		width: ${sizeConfig.medium.width};
		height: ${sizeConfig.medium.height};
	}

	@media only screen and (min-width: ${gridConfig.l.minWidth}) {
		width: ${sizeConfig.large.width};
		height: ${sizeConfig.large.height};
	}
`;

const StyledLoadingSpinnerWrapper = styled.div.attrs({
	className: `${componentName}`,
})``;

// Data testid added via props to add in dynamic
const StyledLoadingSpinner = styled.div.attrs({
	className: `${componentName}__spinner`,
	'data-testid': `${componentName}__spinner`,
})`
	${({ size }) =>
		(size !== 'responsive' &&
			css`
				width: ${sizeConfig?.[`${size}`]?.width};
				height: ${sizeConfig?.[`${size}`]?.height};
			`) ||
		responsiveCss}

	svg {
		animation: fadein ${({ animationTime }) => animationTime}s, rotate 1s linear infinite;

		> circle {
			stroke: ${({ colour }) => colour};
			stroke-linecap: round;
			animation: dash 1.5s ease-in-out infinite;
		}
	}

	${css`
		@keyframes rotate {
			100% {
				transform: rotate(360deg);
			}
		}
	`}

	${css`
		@keyframes fadein {
			from {
				opacity: 0;
			}
			to {
				opacity: 1;
			}
		}
	`}

	${css`
		@keyframes dash {
			0% {
				stroke-dasharray: 1, 150;
				stroke-dashoffset: 0;
			}
			50% {
				stroke-dasharray: 90, 150;
				stroke-dashoffset: -35;
			}
			100% {
				stroke-dasharray: 90, 150;
				stroke-dashoffset: -124;
			}
		}
	`}
`;

export { StyledLoadingSpinnerWrapper, StyledLoadingSpinner };
